/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Found ${i?.count} words you can make from ${i?.letters}.`)
};

const es_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se encontraron ${i?.count} palabras que puedes formar con ${i?.letters}.`)
};

const de_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Wörter gefunden, die du aus ${i?.letters} bilden kannst.`)
};

const nl_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} woorden gevonden die je kunt maken met ${i?.letters}.`)
};

const fr_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mots trouvés que vous pouvez former avec ${i?.letters}.`)
};

const it_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trovate ${i?.count} parole che puoi formare con ${i?.letters}.`)
};

const pt_br2_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encontramos ${i?.count} palavras que você pode formar com ${i?.letters}.`)
};

const pt_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foram encontradas ${i?.count} palavras que pode formar com ${i?.letters}.`)
};

const ja_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.letters} から作れる単語が ${i?.count} 件見つかりました。`)
};

const zh_wu_found = /** @type {(inputs: { count: NonNullable<unknown>, letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从 ${i?.letters} 中找到了 ${i?.count} 个可以拼出的单词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown>, letters: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_found = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_found(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_found", locale)
	if (locale === "en") return en_wu_found(inputs)
	if (locale === "es") return es_wu_found(inputs)
	if (locale === "de") return de_wu_found(inputs)
	if (locale === "nl") return nl_wu_found(inputs)
	if (locale === "fr") return fr_wu_found(inputs)
	if (locale === "it") return it_wu_found(inputs)
	if (locale === "pt-BR") return pt_br2_wu_found(inputs)
	if (locale === "pt") return pt_wu_found(inputs)
	if (locale === "ja") return ja_wu_found(inputs)
	return zh_wu_found(inputs)
};